import { CSSProperties } from 'react';

import './PercentAOIPlaceholder.scss';

interface PercentAOIPlaceholderProps {
  percentage: number;
}

export const PercentAOIPlaceholder = ({ percentage }: PercentAOIPlaceholderProps) => {
  const roundedPercent = Math.round(percentage * 100);

  return (
    <div
      className='percent-aoi-placeholder'
      style={{ '--percentage': `${roundedPercent}%` } as CSSProperties}
    >
      <div className='green-percent-bar' />
    </div>
  );
};
